import React, { useState } from "react";
import "./Courses.css";

import c1 from "../assets/AI-ML.png";
import c2 from "../assets/DataEngineer.png";
import c3 from "../assets/DataAnalyst.png";
import c4 from "../assets/Java.png";
import c5 from "../assets/Python.png";

import { FaRobot, FaDatabase, FaChartBar, FaJava } from "react-icons/fa";
import { SiPython } from "react-icons/si";

const Courses = () => {
  const courses = [
    { img: c1, name: "AI / ML Course" },
    { img: c2, name: "Data Engineer Course" },
    { img: c3, name: "Data Analyst Course" },
    { img: c4, name: "Java Full Stack" },
    { img: c5, name: "Python Full Stack" },
  ];

  const [selectedCourse, setSelectedCourse] = useState(null);

  const handleClick = (course) => {
    setSelectedCourse(course);
  };

  const closeModal = () => {
    setSelectedCourse(null);
  };

  const handleSubmit = () => {
    alert("Form Submitted!");
    setSelectedCourse(null);
  };

  const getIcon = (courseName) => {
    switch (courseName) {
      case "AI / ML Course":
        return <FaRobot />;
      case "Data Engineer Course":
        return <FaDatabase />;
      case "Data Analyst Course":
        return <FaChartBar />;
      case "Java Full Stack":
        return <FaJava />;
      case "Python Full Stack":
        return <SiPython />;
      default:
        return <FaRobot />;
    }
  };

  return (
    <>
      <section className="courses-section">
        <h2 className="courses-title">
          Our <span>Courses</span>
        </h2>

        <div className="courses-grid">
          {courses.map((course, index) => (
            <div
              className="course-card"
              key={index}
              onClick={() => handleClick(course)}
            >
              <img src={course.img} alt="course" />
            </div>
          ))}
        </div>
      </section>

      {selectedCourse && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <span className="close-btn" onClick={closeModal}>
              ×
            </span>

            <div className="modal-left">
              <div className="modal-icon">{getIcon(selectedCourse.name)}</div>
            </div>

            <div className="modal-right">
              <h3 className="course-heading">{selectedCourse.name}</h3>
              <input type="text" placeholder="Full Name" />
              <input type="text" placeholder="Mobile Number" />
              <input type="email" placeholder="Email address" />

              <div className="modal-buttons">
                <button className="skip" onClick={closeModal}>
                  Skip
                </button>
                <button className="submit" onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Courses;
